import { useState, useEffect } from "react";
import { OnboardingControl } from "./OnboardingControl";
import { PlayerDialog } from "./PlayerDialog";
import { PlayerTable } from "./PlayerTable";
import { useDispatch } from "react-redux";
import {
  addTeamPlayer,
  editTeamPlayer,
  getAllPositions,
} from "../../../store/actions/team.actions";
import { PlayerOnboardingLoading } from "./PlayerOnboardingLoading";

export const PlayerOnboarding = ({ userPermissions }) => {
  const dispatch = useDispatch();
  const [createModalOpen, setCreateModalOpen] = useState(false);
  const [editModalOpen, setEditModalOpen] = useState(false);
  const [playerData, setPlayerData] = useState(null);

  const addPlayer = (playerData) => {
    dispatch(
      addTeamPlayer({
        ...playerData,
        name: `${playerData.first_name} ${playerData.last_name}`,
      })
    );
  };

  const editPlayer = (playerData) => {
    dispatch(
      editTeamPlayer({
        ...playerData,
        name: `${playerData.first_name} ${playerData.last_name}`,
      })
    );
  };

  const handleOpenAddModal = () => {
    setCreateModalOpen(true);
  };

  const handleOpenEditModal = (player) => () => {
    setPlayerData(player);
    setEditModalOpen(true);
  };

  const handleCloseModal = () => {
    setCreateModalOpen(false);
    setEditModalOpen(false);
  };

  const canAddPlayer = userPermissions?.RosterAddPlayer == true ? true : false;
  const canEditPlayer = userPermissions?.RosterEditPlayer == true ? true : false;
  const canViewRoster = userPermissions?.RosterViewPlayers == true ? true : false;

  useEffect(() => {
    dispatch(getAllPositions());
  }, []);

  return (
    <PlayerOnboardingLoading>
      <div
        style={{
          width: "100%",
          padding: "0px 0px 16px",
          display: "flex",
          flexDirection: "column",
          gap: 32,
        }}
      >
        <OnboardingControl handleOpenAddModal={handleOpenAddModal} canAddPlayer={canAddPlayer}/>
        {canViewRoster ? <PlayerTable handleOpenEditModal={handleOpenEditModal} userPermissions={userPermissions}/> : <div>You do not have permission to view the roster</div>}
        <PlayerDialog
          open={createModalOpen}
          onCancel={handleCloseModal}
          onSubmit={addPlayer}
          playerData={null}
          disabled={!canAddPlayer}
        />
        <PlayerDialog
          open={editModalOpen}
          onCancel={handleCloseModal}
          onSubmit={editPlayer}
          playerData={playerData}
          disabled={!canEditPlayer}
        />
      </div>
    </PlayerOnboardingLoading>
  );
};
